import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const rollingWindows = [
  { train: [1, 9], test: [10, 12] },
  { train: [4, 12], test: [13, 15] },
  { train: [7, 15], test: [16, 18] },
  { train: [10, 18], test: [19, 21] },
];

const anchoredWindows = [
  { train: [1, 9], test: [10, 12] },
  { train: [1, 12], test: [13, 15] },
  { train: [1, 15], test: [16, 18] },
  { train: [1, 18], test: [19, 21] },
];

function WindowRow({ train, test, total }: { train: number[]; test: number[]; total: number }) {
  const trainWidth = ((train[1] - train[0] + 1) / total) * 100;
  const testWidth = ((test[1] - test[0] + 1) / total) * 100;
  const offset = ((train[0] - 1) / total) * 100;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', height: 20, marginBottom: 4 }}>
      <div style={{ position: 'relative', flex: 1, height: 16, background: '#1e293b', borderRadius: 3 }}>
        <div
          style={{
            position: 'absolute',
            left: `${offset}%`,
            width: `${trainWidth}%`,
            height: '100%',
            background: '#3b82f6',
            opacity: 0.4,
            borderRadius: '3px 0 0 3px',
          }}
        />
        <div
          style={{
            position: 'absolute',
            left: `${offset + trainWidth}%`,
            width: `${testWidth}%`,
            height: '100%',
            background: '#22c55e',
            opacity: 0.6,
            borderRadius: '0 3px 3px 0',
          }}
        />
      </div>
    </div>
  );
}

export default function AnchoredVsRollingMock() {
  const total = 21;

  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Window Modes Comparison</div>
      <div className="platform-mock-body">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
          <div>
            <div style={{ fontSize: '0.7rem', fontWeight: 600, color: '#94a3b8', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Rolling Windows
            </div>
            {rollingWindows.map((w, i) => (
              <WindowRow key={i} train={w.train} test={w.test} total={total} />
            ))}
            <div style={{ fontSize: '0.6rem', color: '#64748b', marginTop: '0.5rem' }}>
              <FontAwesomeIcon icon={faArrowRight} style={{ marginRight: 4 }} />
              Fixed training length, window slides forward
            </div>
          </div>
          <div>
            <div style={{ fontSize: '0.7rem', fontWeight: 600, color: '#94a3b8', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Anchored Windows
            </div>
            {anchoredWindows.map((w, i) => (
              <WindowRow key={i} train={w.train} test={w.test} total={total} />
            ))}
            <div style={{ fontSize: '0.6rem', color: '#64748b', marginTop: '0.5rem' }}>
              <FontAwesomeIcon icon={faArrowRight} style={{ marginRight: 4 }} />
              Training grows, anchored to start
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginTop: '0.75rem', fontSize: '0.625rem', color: '#6b7280' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <span style={{ width: 10, height: 10, background: '#3b82f6', opacity: 0.4, borderRadius: 2, display: 'inline-block' }} /> Train
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <span style={{ width: 10, height: 10, background: '#22c55e', opacity: 0.6, borderRadius: 2, display: 'inline-block' }} /> Test (OOS)
          </span>
        </div>
      </div>
      <div className="platform-mock-caption">Rolling windows keep training length fixed. Anchored windows accumulate all prior data.</div>
    </div>
  );
}
